module.exports = __webpack_public_path__ + "img/telegram.d812ff3f.svg";